import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';
import {
  CreateTablePayload,
  ITable,
  Navigation,
  PagesAndDashboard,
  UpdateTablePayload,
  UpdateTableResponse,
  ValidateTablePayload,
} from '../_models/table.models';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  private baseURL = `${environment.apiUrl}/api`;
  private midURL = '/user';
  private NAVIGATION_URL = '/getnavigation?id=';
  private UPDATE_TABLE = '/applicationtable';
  private ARRANGE_TABLE = '/arrange';
  private DELETE_TABLE = '/applicationtable?id=';
  private VALIDATE_TABLE = '/validtablename';
  private midPageURL = '/applicationtable';
  private PAGE_BY_TABLE = '/defaultpagebytableid?tableId=';
  private UPDATE_PAGE_DASHBOARD = '/defaultpage';
  private TABLE_HAS_DATA = '/tablehasdata';

  public get getNavigationUrl() {
    return `${this.baseURL}${this.midURL}${this.NAVIGATION_URL}`;
  }

  public get getUpdateTableUrl() {
    return `${this.baseURL}${this.UPDATE_TABLE}`;
  }
  public get getArrangeTableUrl() {
    return `${this.baseURL}${this.UPDATE_TABLE}${this.ARRANGE_TABLE}`;
  }

  public get getDeleteTableUrl() {
    return `${this.baseURL}${this.DELETE_TABLE}`;
  }

  public get getValidateTableUrl() {
    return `${this.baseURL}${this.UPDATE_TABLE}${this.VALIDATE_TABLE}`;
  }
  public get getPageByTable() {
    return `${this.baseURL}${this.midPageURL}${this.PAGE_BY_TABLE}`;
  }
  public get getUpdatePageAndDashboard() {
    return `${this.baseURL}${this.UPDATE_TABLE}${this.UPDATE_PAGE_DASHBOARD}`;
  }
  public get getTableHasDataUrl() {
    return `${this.baseURL}${this.UPDATE_TABLE}${this.TABLE_HAS_DATA}`;
  }

  constructor(public http: HttpClient, private authService: AuthService) {}

  getPages = (tableId: string): Observable<Array<PagesAndDashboard>> => {
    return this.http.get<Array<PagesAndDashboard>>(
      `${this.getPageByTable}${tableId}`
    );
  };

  updatePagesAndDashboard = (payload: any): Observable<Array<any>> => {
    return this.http.post<Array<any>>(
      `${this.getUpdatePageAndDashboard}`,
      payload
    );
  };

  /**
   * Get navigation
   */
  getNavigation = (tableId: string): Observable<Array<Navigation>> =>
    this.http.get<Array<Navigation>>(`${this.getNavigationUrl}${tableId}`, {});

  /**
   * update table
   */
  updateTable = (
    payload: UpdateTablePayload
  ): Observable<UpdateTableResponse> =>
    this.http.put<UpdateTableResponse>(
      `${this.getUpdateTableUrl}`,
      payload,
      {}
    );

  /**
   * delete table
   */
  deleteTable = (tableId: string): Observable<void> =>
    this.http.delete<void>(`${this.getDeleteTableUrl}${tableId}`, {});

  /**
   * create table
   */
  createTable = (
    payload: CreateTablePayload
  ): Observable<UpdateTableResponse> =>
    this.http.post<UpdateTableResponse>(
      `${this.getUpdateTableUrl}`,
      payload,
      {}
    );

  /**
   * arrange table
   */
  arrangeTable = (payload: any): Observable<any> =>
    this.http.put<any>(`${this.getArrangeTableUrl}`, payload, {});

  /**
   * Validate name
   */
  validateName = (
    applicationId: string,
    name: string
  ): Observable<ValidateTablePayload> =>
    this.http.post<ValidateTablePayload>(
      `${this.getValidateTableUrl}`,
      { optional: applicationId, value: name },
      {}
    );

  /**
   * Get Tables
   */
  getTables = (applicationId: string): Observable<Array<ITable>> =>
    this.http.get<Array<ITable>>(
      `${this.baseURL}/applicationtable/getbyapplicationid?id=${applicationId}`,
      {}
    );
  /**
   * Get All Tables
   */
  getAllTables = (applicationId: string): Observable<Array<ITable>> =>
    this.http.get<Array<ITable>>(
      `${this.baseURL}/applicationtable/tables-by-app-id?id=${applicationId}`,
      {}
    );

  /**
   * Upload a logo
   */
  uploadLogo = (fd: any): Observable<any> => {
    return this.http.post(`${this.baseURL}/applicationtable/uploadlogo`, fd);
  };

  /**
   * Check if table has data
   * Return TRUE if table has data
   * return FALSE if table is empty
   */
  tableHasData = (tableId: string): Observable<boolean> =>
    this.http.get<boolean>(`${this.getTableHasDataUrl}?id=${tableId}`, {});
}
